<template>
  <div class="form-status" :class="classes">
    <div class="container">
      <i class="form-status__icon"></i>
      <div class="form-status__title">{{ title0 }}</div>
      <div class="form-status__message">{{ message0 }}</div>
      <div class="form-status__action">
        <button class="btn" type="button"
            :class="{'btn_inverse':theme==='inverse'}" @click="$emit('close')">
          Ok
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props   : [
      'status',
      'title',
      'message',
      'theme',
    ],
    data() {
      return {
        title0  : 'Title',
        message0: 'Message',
        text    : {
          success: {
            title  : 'Ваша заявка принята',
            message: 'Наш менеджер свяжется с вами в ближайшее время',
          },
          error  : {
            title  : 'Не удалось отправить заявку',
            message: 'Попробуйте ещё раз',
          },
        },
      };
    },
    mounted() {
      if (this.status === true) {
        this.title0   = this.title ? this.title : this.text.success.title;
        this.message0 = this.message ? this.message : this.text.success.message;
      }

      if (this.status === false) {
        this.title0   = this.title ? this.title : this.text.error.title;
        this.message0 = this.message ? this.message : this.text.error.message;
      }
    },
    computed: {
      classes: function() {
        let cls = '';
        if (this.status !== null) {
          cls += this.status ? ' form-status_ok' : ' form-status_fail';
        }

        if (this.theme) {
          cls += ` form-status_theme_${this.theme}`;
        }

        return cls;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// FormStatus.vue?70c99334